<template>
    <span>
        <span class="text-success ml-1" v-if="feriado.ativo"
            ><i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar Feriado"
                @click.stop="confirmaAtivarDesativar()"
                v-if="mostrarBtnAtivarDesativar"
            ></i
        ></span>
        <span class="text-secondary ml-1" v-if="!feriado.ativo"
            ><i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar Feriado"
                @click.stop="confirmaAtivarDesativar()"
                v-if="mostrarBtnAtivarDesativar"
            ></i
        ></span>
    </span>
</template>

<script>
import FeriadosServicos from './FeriadosServicos'

export default {
    props: {
        feriado: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        confirmaAtivarDesativar() {
            let titulo = `${
                this.feriado.ativo ? 'Desativação' : 'Ativação'
            } de Feriado`
            let texto = `Confirma a ${
                this.feriado.ativo ? 'desativação' : 'ativação'
            } do Feriado <b>${this.feriado.descricao}</b>?`
            this.$swal({
                title: titulo,
                html: texto,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.ativarDesativarFeriado()
                }
            })
        },

        ativarDesativarFeriado() {
            this.$store.dispatch('addRequest')
            FeriadosServicos.ativarDesativarFeriado(this.feriado.feriadoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Feriado atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFeriados')
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar feriado.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    computed: {
        mostrarBtnAtivarDesativar() {
            return this.$temAcessoView('ADMIN-FERIADOS-05')
        }
    }
}
</script>
